module.exports = __webpack_public_path__ + "img/ZIP_system_icon@2x.c86c2ea9.png";